import { call, put, takeEvery, actionChannel } from 'redux-saga/effects';

import { actions } from '@tvguide/store/actions/requests';
import {
  updateProgram,
  addProgramsToSpecificChannel,
} from '@store/actions/programs';
import API from '@api';

function* fetchMoreEpisodes(action) {
  try {
    const relatedPrograms = yield call(
      API.getProgramMoreEpisodes.bind(API),
      action.nid,
      action.pid,
    );
    // Make sure we have related programs before we continue.
    if (relatedPrograms.length !== 0) {
      yield put(addProgramsToSpecificChannel(action.sid, relatedPrograms));
      yield put(
        updateProgram(action.sid, action.id, {
          related: relatedPrograms.map(p => p.uuid),
          requesting: false,
        }),
      );
    }
  } catch (e) {}
}

function* moreEpisodeSaga() {
  const channel = yield actionChannel(actions.moreEpisodes);
  yield takeEvery(channel, fetchMoreEpisodes);
}

export default moreEpisodeSaga;
